import { WebLayout } from 'components/Layout';
import React, { useEffect, useState } from 'react';
import {
  StreamTheme,
  StreamVideo,
  StreamVideoClient,
  LivestreamPlayer,
} from '@stream-io/video-react-sdk';
import '@stream-io/video-react-sdk/dist/css/styles.css';

const apiKey = 'gnu5anqa7t9c';
const token =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJAc3RyZWFtLWlvL2Rhc2hib2FyZCIsImlhdCI6MTc0ODQxOTU1MSwiZXhwIjoxNzQ4NTA1OTUxLCJ1c2VyX2lkIjoiIWFub24iLCJyb2xlIjoidmlld2VyIiwiY2FsbF9jaWRzIjpbImxpdmVzdHJlYW06bGl2ZXN0cmVhbV9mN2NmZDgxMy0zMWNlLTQyMjUtOTIzMS02Nzg5NTU3Y2NhMjYiXX0.KUb8nuGkHApanXDx0yHHEs2YELHJq5WFhLVbZxQZkmA'; // your full token here
const callId = 'livestream_f7cfd813-31ce-4225-9231-6789557cca26';
const user = { type: 'anonymous' };

const client = new StreamVideoClient({ apiKey, user, token });

export const LiveSessions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <WebLayout>
      <h1 className="text-4xl md:text-7xl text-center md:text-start font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-purple-800 via-pink-600 to-[#F9A200] league-spartan-extra-bold mb-4">
        Live Sessions
      </h1>

      <div className="min-h-[400px] flex items-center justify-center bg-black rounded-lg p-4 shadow-lg">
        <StreamTheme>
          <StreamVideo client={client}>
            <LivestreamPlayer callType="livestream" callId={callId} />
          </StreamVideo>
        </StreamTheme>
      </div>
    </WebLayout>
  );
};
